// extracted by mini-css-extract-plugin
module.exports = {"loader":"_2Wv-8","spinner":"it5I_","rotate-ltr":"_62ELM","rotateLtr":"_62ELM","rotate-rtl":"_2lRtX","rotateRtl":"_2lRtX","path":"_24szN","dash":"_1G1Vx"};